var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9486_13913)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.0008 7C14.0008 7.55228 14.4483 8 15.0003 8C15.5524 8 15.9999 7.55228 15.9999 7V6C15.9999 3.79086 14.2098 2 12.0016 2H6.0051C3.79692 2 2.00684 3.79086 2.00684 6L2.00684 18C2.00684 20.2091 3.79692 22 6.0051 22H12.0086C14.2168 22 16.0068 20.2091 16.0068 18V17C16.0068 16.4477 15.5593 16 15.0073 16C14.4552 16 14.0077 16.4477 14.0077 17V18C14.0077 19.1046 13.1127 20 12.0086 20H6.0051C4.90101 20 4.00597 19.1046 4.00597 18L4.00597 6C4.00597 4.89543 4.90101 4 6.0051 4H12.0016C13.1057 4 14.0008 4.89543 14.0008 6V7Z",
    fill: "#8405DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11L9 11C8.44771 11 8 11.4477 8 12C8 12.5523 8.44771 13 9 13L19 13Z",
    fill: "#8405DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2929 9.70711C16.9024 9.31658 16.9024 8.68342 17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289L21.7071 11.2929C22.0976 11.6834 22.0976 12.3166 21.7071 12.7071L18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071C16.9024 15.3166 16.9024 14.6834 17.2929 14.2929L19.5858 12L17.2929 9.70711Z",
    fill: "#8405DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9486_13913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3c19bec93d821a6767c0531040177782.svg";
export { ForwardRef as ReactComponent };